/**
 * @ondit/logger
 *
 * Module-tagged console logging for the Agent's browser code. Every level
 * prints, through the console method of the same name, so the browser's own
 * level filter decides what is shown and objects stay inspectable.
 */

export interface Logger {
  debug(message: string, ...args: unknown[]): void
  info(message: string, ...args: unknown[]): void
  warn(message: string, ...args: unknown[]): void
  error(message: string, ...args: unknown[]): void
}

export function createLogger(module: string): Logger {
  const tag = `[${module}]`
  return {
    debug: (message, ...args) => console.debug(tag, message, ...args),
    info: (message, ...args) => console.info(tag, message, ...args),
    warn: (message, ...args) => console.warn(tag, message, ...args),
    error: (message, ...args) => console.error(tag, message, ...args),
  }
}
